import { isUserHasAccount } from "./services/activation";

export async function accountProfileActivation(
  accessToken,
  currentUser
): Promise<boolean> {
  return await isUserHasAccount(accessToken);
}
